import { HoverPopover } from '@app/components/base/HoverPopover';
import { toTimestamp } from '@mi-front/core';
import { StreamEl, theme } from '@mi-front/ui';
import { useContext } from 'react';
import { DiarizationContext } from '../../../diarization/DiarizationContext';
import { DiarizationInfo } from '../diarization/DiarizationInfo';
import { formatVoiceLabel, isNumeric } from '../transcriptions/utils';
import { DiarizationMarkerLabel } from './elements';

interface Props {
  readonly diarization: any;
}

/**
 * Renders a diarization (speaker) marker on the focus strip. Uses MUI Popover
 * via HoverPopover so the info popup appears above other strips (e.g. Live Topics).
 */
export function DiarizationMarker({ diarization }: Props) {
  const { speakers } = useContext(DiarizationContext);

  const speaker = speakers.find((item) => {
    return item.speaker === formatVoiceLabel(diarization.voice_label);
  });

  return (
    <StreamEl
      key={diarization.time}
      ts={toTimestamp(diarization.time) + diarization.segment.start * 1000}
      offsetX={-18}
      position="bottom"
      zIndex={2}
    >
      <HoverPopover
        trigger={
          <DiarizationMarkerLabel color={speaker?.color ?? theme.aqua}>
            <div
              style={{
                fontSize: '0.75rem',
              }}
            >
              {diarization.voice_label
                .split('-')
                .map((item: string) => item[0].toUpperCase())
                .filter((value: string) => !isNumeric(value))
                .join('')}
            </div>
          </DiarizationMarkerLabel>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        paperSx={{ minWidth: 200 }}
        delay={150}
      >
        <DiarizationInfo diarization={diarization} />
      </HoverPopover>
    </StreamEl>
  );
}
